import React from 'react'

const PriceInputWrapper = React.forwardRef((props, ref) => (
  <label className='game-form-label'>
    {props.label}
    <div className='dollar-field inline'>
      <input className='form-control' type='number' step='0.01' min='0' max='1000000' {...props} ref={ref} />
    </div>
    {props.error && <div className='error_container'>{props.error.message}</div>}
  </label>
))

export default PriceInputWrapper
